import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Tasks } from "../Types/Task/TaskInterface";
import { getAllTaskData } from "../Thunks/taskThunks";

interface TaskState {
    allTasks: Tasks[];
    loadingTask: boolean;
    errorTask: string | null;
    
}

const initialState: TaskState = {
    allTasks: [],
    loadingTask: false,
    errorTask: null
}

const taskSlice = createSlice ({
    name: 'Task',
    initialState,
    reducers : {},
    extraReducers(builder){
        builder.addCase(getAllTaskData.rejected, (state, action) => {
            state.loadingTask = false;
            state.errorTask = action.error.message!;
          })
            .addCase(getAllTaskData.pending, state => {
            state.loadingTask = true;
            state.errorTask = null;
          })
          .addCase(getAllTaskData.fulfilled, (state, action: PayloadAction<Tasks[]>) => {
            state.loadingTask = false;
            state.allTasks = action.payload!;
            
          })
    }

})

export const {} = taskSlice.actions
export default taskSlice.reducer